import NoRecord from "../../components/NoRecord";
import PanelLayout from "../../layout/PanelLayout";
import { useLocation, useNavigate } from "react-router-dom";

const BrowseCategory = () => {
  const navigate = useNavigate();
  const assetCategoryList = useLocation()?.state?.assetCategoryList || [];
  return (
    <PanelLayout>
      <section class="ct_py_80">
        <div class="container">
          <div class="d-flex align-items-start gap-3 mb-2">
            <div>
              <h5 class="ct_fs_24 ct_fw_600">
                {" "}
                <a class="ct_back_icon ct_fs_18">
                  <i
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(-1);
                    }}
                    class="fa-solid fa-angle-left"
                  ></i>
                </a>
                Browse by Category
              </h5>
              <p class="mb-0 ct_text_clr_4B5563">
                Explore assets across different categories
              </p>
            </div>
          </div>

          {assetCategoryList?.length > 0 ? (
            <div class="category-grid ct_mt_30">
              {assetCategoryList?.map((item, index) => (
                <div class="category-item">
                  <img src={item?.categoryImage || ""} alt="img" />
                  <div class="text">
                    <h6>{item?.categoryName || "#N/A"}</h6>
                    <span>
                      {item?.count || 0} item{item?.count > 1 ? "s" : ""}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <NoRecord />
          )}
          {/* <div class="category-item">
              <img src="assets/img/browse-category-1.png" />
              <div class="text">
                <h6>Mobile Devices</h6>
                <span>5,000 items</span>
              </div>
            </div> */}

          <hr class="ct_border_bottom" />
        </div>
      </section>
    </PanelLayout>
  );
};

export default BrowseCategory;
